<template>
  <div>
    <b-row class = "selProType">
      <h5 class="processTypeLabel">{{ $t('ANALYTICS.SELECT_PROCESS_TYPE') }}</h5>
      <b-col>
        <b-form-select class="formselectPT" v-model="selectedFilterProcessType" :options="processTypes"></b-form-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="4">
        <b-card>
          <template v-slot:header>
            <b-row class = "headers">
              <h5>{{ $t('CONFIGURED.FIELDS') }}</h5>
              <b-col cols = "6">
                <b-form-input v-model="filter" class = "searchBox" @input = "searchByText()" placeholder="Search"></b-form-input>
              </b-col>
              <b-col class="text-right" style="padding-right: 0px;">
                <b-button v-b-tooltip.hover size="sm" class = "addGroupBtn" variant="secondary" :title="$t('CONFIGURED.ADD_GROUP')" @click="showAddFieldModal()"><i class="fa fa-plus"> </i> <span>{{ $t('COMMON.ADD') }} </span></b-button>
              </b-col>
            </b-row>
          </template>
          <div id = "groups">
            <div v-if = "!fieldsLoaded">
              <content-placeholders>
                <content-placeholders-img :style="{height: '280px'}" />
              </content-placeholders>
            </div>
            <div v-if = "selectedFilterProcessType === null && fieldsLoaded ">
              <b-row>
                <b-col><br>
                  <a style="color: red;">Please Select Process type</a>
                </b-col>
              </b-row>
            </div>
            <div v-else-if = "fields.length === 0 && fieldsLoaded">
              <b-row>
                <b-col><br>
                  <h4 style="color: red; ">{{ $t('FORMS.NOTHING') }}</h4>
                </b-col>
              </b-row>
            </div>
            <div v-if = "fieldsLoaded" v-for = "(processField) in fields">
              <b-row @click="getFieldAlias(processField)" class = "groupName" v-if = "currentField.id === processField.id">
                <a class="selectedField">{{processField.field.replace(/_/g, ' ')| capitalize}}</a>
                <b-col class="text-right">
                  <div class="actionBtn">
                    <a v-b-tooltip.hover :title="$t('COMMON.EDIT')" class="editBtnSelect" @click = "openEditField(processField)"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                    <a v-b-tooltip.hover :title="$t('COMMON.DELETE_PERMANENTLY')" @click = "confirmDeleteField(processField)" ><i style="color:red;" class="fa fa-trash" aria-hidden="true"></i></a>
                  </div>
                </b-col>
              </b-row>
              <b-row @click="getFieldAlias(processField)" v-else>
                <a class="unselectedRows">{{processField.field.replace(/_/g, ' ')| capitalize}}</a>
                <b-col class="text-right">
                  <div class="actionBtn">
                    <a v-b-tooltip.hover :title="$t('COMMON.EDIT')" class="editBtnSelect" @click = "openEditField(processField)"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                    <a v-b-tooltip.hover :title="$t('COMMON.DELETE_PERMANENTLY')" @click = "confirmDeleteField(processField)" ><i style="color:red;" class="fa fa-trash" aria-hidden="true"></i></a>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
      </b-col>
    <b-col cols="8">
      <b-card>
        <template v-slot:header>
          <b-row class = "headers">
            <b-col>
              <h5>{{ $t('CONFIGURED.FIELDS_ALIASES') }}</h5>
            </b-col>
            <b-col v-if="currentFieldAliases !== null" class="text-right">
              <b-button v-b-tooltip.hover size="sm" class = "addGroupBtn" variant="secondary" :title="$t('CONFIGURED.ADD_FIELD_ALIAS')" @click="showAddFieldAliasModal()"><i class="fa fa-plus"> </i> <span>{{ $t('COMMON.ADD') }} </span></b-button>
            </b-col>
          </b-row>
        </template>
        <div class="labelBody">
          <div v-if = "!fieldAliasLoaded">
            <content-placeholders>
              <content-placeholders-img :style="{height: '250px'}" />
            </content-placeholders>
          </div>
          <div v-else v-for="(fieldAlias,index) in currentFieldAliases">
            <div class="currFields" v-if = "fieldAlias.name !== null">
              {{fieldAlias.name}}
              <div class="pull-right">
                <a v-b-tooltip.hover :title="$t('COMMON.EDIT')" class="fieldEditBtn" @click = "showEditFieldAliasModal(fieldAlias)"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                <a v-b-tooltip.hover :title="$t('COMMON.DELETE_PERMANENTLY')"@click = "showDeleteFieldAliasModal(fieldAlias)" ><i style="color:red;" class="fa fa-trash" aria-hidden="true"></i></a>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
    </b-row>

    <b-modal centered hide-header-close id = "DeleteConfirmationGrp" ref="deleteGrp" :title="$t('COMMON.DELETE_CONFIRM')">
      <p style="color: red;">{{ $t('COMMON.MSG_PERM_DEL') }}</p>
      <div slot="modal-footer">
        <b-btn id ="addNewField" size="sm" variant="secondary" @click="deleteField()">{{ $t('COMMON.DELETE') }} </b-btn>
        <b-btn size="sm" variant="light" @click="$refs.deleteGrp.hide()"> {{ $t('COMMON.CLOSE') }} </b-btn>
      </div>
    </b-modal>

    <b-modal centered hide-header-close id = "DeleteConfirmationField" ref="ConfirmModal" :title="$t('COMMON.DELETE_CONFIRM')">
      <p style="color: red;">{{ $t('COMMON.MSG_PERM_DEL') }}</p>
      <div slot="modal-footer">
        <b-btn id ="addNewField" size="sm" variant="secondary" @click="deleteFieldAlias()">{{ $t('COMMON.DELETE') }} </b-btn>
        <b-btn size="sm" variant="light" @click="$refs.ConfirmModal.hide()"> {{ $t('COMMON.CLOSE') }} </b-btn>
      </div>
    </b-modal>

    <b-modal centered hide-header-close id = "FieldAliasModal" ref="FieldAliasModal" :title="$t('CONFIGURED.ADD_ALIAS')">
      <b-form-group>
        <b-row>
          <b-col sm="2">
            <label>{{ $t('COMMON.NAME') }}</label>
            <span class="required">*</span>
          </b-col>
          <b-col sm="8">
            <b-form-input v-model="newFieldAliasName" @input = "checkDuplicateAlias" placeholder="Enter"></b-form-input>
            <a v-if="errorFieldDup" style="color:red;">{{ $t('CONFIGURED.FIELD_EXISTS') }} </a>
          </b-col>
        </b-row>
      </b-form-group>
      <div slot="modal-footer">
        <b-btn id ="addNewField" size="sm" variant="secondary" @click="addFieldAlias()" :disabled = "errorFieldDup || newFieldAliasName === ''">{{ $t('COMMON.SAVE') }} </b-btn>
        <b-btn size="sm" variant="light" @click="$refs.FieldAliasModal.hide()"> {{ $t('COMMON.CLOSE') }} </b-btn>
      </div>
    </b-modal>

    <b-modal centered hide-header-close id = "editFieldAliasModal" ref="editFieldAliasModal" :title="$t('CONFIGURED.EDIT_ALIAS')">
      <b-form-group>
        <b-row>
          <b-col sm="2">
            <label>{{ $t('COMMON.NAME') }}</label>
            <span class="required">*</span>
          </b-col>
          <b-col sm="8">
            <b-form-input v-model="newFieldAliasName" @input = "checkDuplicateAlias" placeholder="Enter"></b-form-input>
            <a v-if="errorFieldDup" style="color:red;">{{ $t('CONFIGURED.FIELD_EXISTS') }} </a>
          </b-col>
        </b-row>
      </b-form-group>
      <div slot="modal-footer">
        <b-btn id ="addNewField" size="sm" variant="secondary" @click="editFieldAlias()" :disabled = "errorFieldDup || newFieldAliasName === ''">{{ $t('COMMON.SAVE') }} </b-btn>
        <b-btn size="sm" variant="light" @click="$refs.editFieldAliasModal.hide()"> {{ $t('COMMON.CLOSE') }} </b-btn>
      </div>
    </b-modal>

    <b-modal centered hide-header-close ref="addFieldModal" :title="$t('CONFIGURED.ADD_GROUP')">
      <div>
        <b-form-group>
          <b-row>
            <b-col sm="4">
              <label>{{ $t('CONFIGURED.FIELD') }}</label>
              <span class="required">*</span>
            </b-col>
            <b-col sm="8">
              <b-form-input  class="rolename" id="roleName"
                  type="text" :placeholder="$t('CONFIGURED.FIELD')"
                  :class="{'is-invalid': $v.newFieldName.$error, 'is-valid': !$v.newFieldName.$invalid}"
                  v-model="newFieldName"
                  @input="$v.newFieldName.$touch()">
                </b-form-input>
               <b-form-invalid-feedback v-if="!$v.newFieldName.isUnique">Either Group is already registered or not allowed.</b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group>
          <b-row>
            <b-col sm="4">
              <label>{{ $t('CONFIGURED.FIELD_TYPE') }}</label>
              <span class="required">*</span>
            </b-col>
            <b-col>
              <b-form-select v-model="selectedFieldType" :options="fieldTypes"></b-form-select>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group v-if="this.selectedFieldType === 'name'">
          <b-row>
            <b-col sm="4">
              <label>Field Children</label>
              <span class="required">*</span>
            </b-col>
            <b-col>
              <multiselect class="custom-multiselect" style="z-index: 99;" v-model="selectedFieldChildren" :options="fieldChildren" track-by="value" label="text" :multiple="true"></multiselect>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-radio-group>
          <b-row>
            <b-col sm="4">
              <label>Extract</label>
            </b-col>
            <b-col sm="4">
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="extractYes" class="custom-control-input" :value="true" v-model="extract">
                <label class="custom-control-label" for="extractYes">{{ $t('COMMON.YES') }}</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="extractNo" class="custom-control-input" :value="false" v-model="extract">
                <label class="custom-control-label" for="extractNo">{{ $t('COMMON.NO') }}</label>
              </div>
            </b-col>
          </b-row>
        </b-form-radio-group>
        <div v-if="this.selectedFilterProcessType === 'insurance_cards'">
          <b-form-group>
            <b-row>
              <b-col sm="4">
                <label>{{ $t('CONFIGURED.FIELD_ALIAS') }}</label>
                <span class="required">*</span>
              </b-col>
              <b-col sm="8">
                <b-form-input  class="rolename" id="roleName"
                    type="text" :placeholder="$t('CONFIGURED.FIELD_ALIAS')"
                    v-model="newFieldAlias">
                  </b-form-input>
                <!-- <b-form-invalid-feedback v-if="!$v.newFieldName.isUnique">Either Group is already registered or not allowed.</b-form-invalid-feedback> -->
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-radio-group>
            <b-row>
              <b-col sm="4">
                <label>{{ $t('CONFIGURED.REQ') }}</label>
              </b-col>
              <b-col sm="4">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="requiredNewYes" class="custom-control-input" :value="true" v-model="isRequired">
                  <label class="custom-control-label" for="requiredNewYes">{{ $t('COMMON.YES') }}</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="requiredNewNo" class="custom-control-input" :value="false" v-model="isRequired">
                  <label class="custom-control-label" for="requiredNewNo">{{ $t('COMMON.NO') }}</label>
                </div>
              </b-col>
            </b-row>
          </b-form-radio-group>
          <b-form-group>
            <b-row>
              <b-col sm="4">
                <label>{{ $t('CONFIGURED.QUERY') }}</label>
                <span class="required">*</span>
              </b-col>
              <b-col cols="4">
                <b-form-textarea placeholder="Query" rows="4" v-model="editQuery">
                </b-form-textarea>
              </b-col>
            </b-row>
          </b-form-group>
        </div>
      </div>
      <div slot="modal-footer">
          <b-btn size="sm" variant="secondary" @click="addField()" :disabled ="!$v.newFieldName.isUnique || selectedFieldType === null || newFieldName === '' || editQuery === '' || newFieldAlias === '' || (selectedFieldType === 'name' ? selectedFieldChildren === [] : false)"> Save </b-btn>
          <b-btn size="sm" variant="light" @click="$refs.addFieldModal.hide()"> {{ $t('COMMON.CLOSE') }} </b-btn>
      </div>
    </b-modal>

    <b-modal centered hide-header-close ref="editGroupModal" :title="$t('CONFIGURED.EDIT_GROUP') ">
      <div>
        <b-form-group>
          <b-row>
            <b-col sm="4">
              <label>{{ $t('CONFIGURED.FIELD') }}</label>
              <span class="required">*</span>
            </b-col>
            <b-col sm="8">
              <b-form-input  class="rolename" id="roleName"
                  type="text" :placeholder="$t('CONFIGURED.FIELD')"
                  :class="{'is-invalid': $v.newFieldName.$error, 'is-valid': !$v.newFieldName.$invalid}"
                  v-model="newFieldName"
                  @input="$v.newFieldName.$touch()">
                </b-form-input>
               <b-form-invalid-feedback v-if="!$v.newFieldName.isUnique">Either Group is already registered or not allowed.</b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group>
          <b-row>
            <b-col sm="4">
              <label>{{ $t('CONFIGURED.FIELD_TYPE') }}</label>
              <span class="required">*</span>
            </b-col>
            <b-col>
              <b-form-select v-model="selectedFieldType" :options="fieldTypes"></b-form-select>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group v-if="this.selectedFieldType === 'name'">
          <b-row>
            <b-col sm="4">
              <label>Field Children</label>
              <span class="required">*</span>
            </b-col>
            <b-col>
              <multiselect class="custom-multiselect" style="z-index: 99;" v-model="selectedFieldChildren" :options="fieldChildren" track-by="text" label="text" :multiple="true"></multiselect>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-radio-group>
          <b-row>
            <b-col sm="4">
              <label>Extract</label>
            </b-col>
            <b-col sm="4">
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="extractYes" class="custom-control-input" :value="true" v-model="extract">
                <label class="custom-control-label" for="extractYes">{{ $t('COMMON.YES') }}</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="extractNo" class="custom-control-input" :value="false" v-model="extract">
                <label class="custom-control-label" for="extractNo">{{ $t('COMMON.NO') }}</label>
              </div>
            </b-col>
          </b-row>
        </b-form-radio-group>
        <div v-if="this.selectedFilterProcessType === 'insurance_cards'">
          <b-form-group>
            <b-row>
              <b-col sm="4">
                <label>{{ $t('CONFIGURED.FIELD_ALIAS') }}</label>
                <span class="required">*</span>
              </b-col>
              <b-col sm="8">
                <b-form-input  class="rolename" id="roleName"
                    type="text" :placeholder="$t('CONFIGURED.FIELD_ALIAS')"
                    v-model="newFieldAlias">
                  </b-form-input>
                <!-- <b-form-invalid-feedback v-if="!$v.newFieldName.isUnique">Either Group is already registered or not allowed.</b-form-invalid-feedback> -->
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-radio-group>
            <b-row>
              <b-col sm="4">
                <label>{{ $t('CONFIGURED.REQ') }}</label>
              </b-col>
              <b-col sm="4">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="requiredNewYes" class="custom-control-input" :value="true" v-model="isRequired">
                  <label class="custom-control-label" for="requiredNewYes">{{ $t('COMMON.YES') }}</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="requiredNewNo" class="custom-control-input" :value="false" v-model="isRequired">
                  <label class="custom-control-label" for="requiredNewNo">{{ $t('COMMON.NO') }}</label>
                </div>
              </b-col>
            </b-row>
          </b-form-radio-group>
          <b-form-group>
            <b-row>
              <b-col sm="4">
                <label>{{ $t('CONFIGURED.QUERY') }}</label>
                <span class="required">*</span>
              </b-col>
              <b-col cols="4">
                <b-form-textarea placeholder="Query" rows="4" v-model="editQuery">
                </b-form-textarea>
              </b-col>
            </b-row>
          </b-form-group>
        </div>
      </div>
      <div slot="modal-footer">
          <b-btn size="sm" variant="secondary" @click="editFieldName()" :disabled ="!$v.newFieldName.isUnique || selectedFieldType === null || newFieldName === '' || editQuery === '' || newFieldAlias === ''"> Save </b-btn>
          <b-btn size="sm" variant="light" @click="$refs.editGroupModal.hide()"> {{ $t('COMMON.CLOSE') }} </b-btn>
      </div>
    </b-modal>
  </div>  
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'

export default {
  data () {
    return {
      fieldTypes: null,
      fieldChildren: [],
      processTypes: null,
      selectedFieldType: null,
      selectedFieldChildren: [],
      newFieldAliasName: '',
      errorFieldDup: false,
      currentFieldAliases: null,
      selectedFieldAlias: null,
      currentField: {id: null},
      filter: '',
      newFieldName: '',
      fields: [],
      fetched_fields: [],
      selectedFilterProcessType: 'insurance_cards',
      fieldsLoaded: false,
      fieldAliasLoaded: true,
      isRequired: false,
      extract: true,
      editQuery: '',
      newFieldAlias: ''
    }
  },
  created () {
    this.getFields()
    this.fieldTypes = [{text: 'Select Field Type', value: null, disabled: true},
      {text: 'Alphabets', value: 'alphabets'},
      {text: 'Alphanumeric', value: 'alphanumeric'},
      {text: 'Character', value: 'character'},
      {text: 'Currency', value: 'currency'},
      {text: 'Date', value: 'date'},
      {text: 'One word', value: 'one_word'},
      {text: 'One word alphanumeric', value: 'one_word_alphanumeric'},
      {text: 'String', value: 'string'},
      {text: 'Number', value: 'number'},
      {text: 'Payment terms', value: 'payment_terms'},
      {text: 'Vertical multiple lines', value: 'vertical_multiple_lines'},
      {text: 'Name', value: 'name'}
    ]
    this.processTypes = [{text: 'Select Process Type', value: null, disabled: true},
      {text: this.$t('UPLOAD_DROPDOWN.DL'), value: 'driving_licence'},
      {text: this.$t('UPLOAD_DROPDOWN.INSURANCE'), value: 'insurance_cards'},
      {text: this.$t('UPLOAD_DROPDOWN.INVOICE'), value: 'invoice'}
    ]
  },
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters(['idToken'])
  },
  watch: {
    selectedFilterProcessType: function () {
      this.getFields()
      this.currentFieldAliases = null
    },
    selectedFieldType: function (newVal) {
      if (newVal === 'name') {
        this.getFieldChildren((this.fields))
      }
    }
  },
  methods: {
    showAddFieldModal () {
      this.newFieldName = ''
      this.currentField = {
        id: null
      }
      this.selectProcessType = null
      this.selectedFieldType = null
      this.selectedFieldChildren = []
      this.editQuery = ''
      this.newFieldAlias = ''
      this.$refs.addFieldModal.show()
    },
    getFields () {
      this.fieldsLoaded = false
      Vue.axios.get('settings/process_field', { headers: { Authorization: `Bearer ${this.idToken}` },
        params: { process_type: this.selectedFilterProcessType } })
        .then(res => {
          this.fields = res.data.fields
          this.fetched_fields = res.data.fields
          this.getFieldAlias(res.data.fields[0])
          if (this.filter.length > 1) {
            this.searchByText()
          }
          this.fieldsLoaded = true
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    getFieldChildren (fields) {
      this.fieldChildren = []
      fields.forEach(field => {
        if (field.extract === false) {
          this.fieldChildren.push({text: field.alias, value: field.alias})
        }
      })
    },
    openEditField (processField) {
      this.currentField = processField
      this.newFieldName = processField.field.replace(/_/g, ' ')
      this.editQuery = processField.query
      this.isRequired = processField.required
      this.extract = processField.extract
      this.selectedFieldChildren = []
      if (processField.children && processField.children.length > 0) {
        processField.children.forEach(value => {
          this.selectedFieldChildren.push({text: value, value: value})
        })
      }
      this.newFieldAlias = processField.alias
      this.selectedFieldType = processField.field_type
      this.$refs.editGroupModal.show()
    },
    editFieldName () {
      let group = {
        new_field: this.newFieldName.trim().replace(/\s+/g, '_').toLowerCase(),
        field_type: this.selectedFieldType,
        field_alias: this.newFieldAlias,
        required: this.isRequired,
        field_query: this.editQuery,
        extract: this.extract,
        field_children: this.selectedFieldChildren.map((ele) => ele.value)
      }
      Vue.axios.patch('settings/process_field/' + this.currentField.id, group, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.success) {
            let newFields = this.fields.map(field => {
              if (field.id === res.data.field.id) {
                return res.data.field
              } else {
                return field
              }
            })
            this.fields = newFields
            this.$refs.editGroupModal.hide()
            Vue.toasted.show('Sucessfully Updated')
          } else {
            Vue.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    addFieldAlias () {
      let newFieldAlias = {
        field_alias_name: this.newFieldAliasName.trim().toLowerCase(),
        field_id: this.currentField.id,
        process_type: this.selectedFilterProcessType
      }
      Vue.axios.post('settings/process_field_alias', newFieldAlias, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.success) {
            this.currentFieldAliases.push(res.data.field_alias)
            this.$refs.FieldAliasModal.hide()
            Vue.toasted.show('Added Sucessfully')
          } else {
            Vue.toasted.show(res.data.msg, { type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    editFieldAlias () {
      let newFieldAlias = {
        new_field: this.newFieldAliasName.trim().toLowerCase(),
        process_type: this.selectedFilterProcessType
      }
      Vue.axios.patch('settings/process_field_alias/' + this.selectedFieldAlias.id, newFieldAlias, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.success) {
            this.currentFieldAliases = this.currentFieldAliases.map(fieldAlias => {
              return fieldAlias.id === res.data.field_alias.id ? res.data.field_alias : fieldAlias
            })
            this.$refs.editFieldAliasModal.hide()
            Vue.toasted.show('Updated Sucessfully')
          } else {
            Vue.toasted.show(res.data.msg, { type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    deleteFieldAlias () {
      Vue.axios.delete('settings/process_field_alias/' + this.selectedFieldAlias.id, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.success) {
            for (var i = 0; i < this.currentFieldAliases.length; i++) {
              if (this.currentFieldAliases[i].id === res.data.field_alias.id) {
                this.currentFieldAliases.splice(i, 1)
              }
            }
            this.$refs.ConfirmModal.hide()
            Vue.toasted.show('Deleted Sucessfully')
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    addField () {
      let field = {
        process_type: this.selectedFilterProcessType,
        field: this.newFieldName.trim().replace(/\s+/g, '_').toLowerCase(),
        field_type: this.selectedFieldType,
        extract: this.extract,
        template_doc_id: this.selectedFilterProcessType === 'insurance_cards' ? -2 : null,
        query: this.editQuery,
        alias: this.newFieldAlias,
        required: this.isRequired
      }
      if (this.selectedFieldChildren && this.selectedFieldChildren.value) {
        field.field_children = this.selectedFieldChildren.value
      } else {
        field.field_children = []
      }
      Vue.axios.post('settings/process_field', field, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.success) {
            this.currentField = res.data.field
            this.fields.push(res.data.field)
            this.currentFieldAliases = []
            this.$refs.addFieldModal.hide()
            this.scrollFieldToBottom()
            Vue.toasted.show('Sucessfully Added')
          } else {
            Vue.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    scrollFieldToBottom () {
      setTimeout(function () {
        var fieldsGroup = document.getElementById('groups')
        document.getElementById('groups').scrollTo(0, fieldsGroup.scrollHeight + 100)
      }, 100)
    },
    checkDuplicateAlias () {
      let fields = this.currentFieldAliases.filter(field => {
        if (this.newFieldAliasName === field.name && field.id !== this.selectedFieldAlias.id) {
          return true
        }
      })
      this.errorFieldDup = !(fields.length === 0)
    },
    showDeleteFieldAliasModal (fieldAlias) {
      this.selectedFieldAlias = fieldAlias
      this.$refs.ConfirmModal.show()
    },
    showEditFieldAliasModal (fieldAlias) {
      this.selectedFieldAlias = fieldAlias
      this.newFieldAliasName = fieldAlias.name
      this.$refs.editFieldAliasModal.show()
    },
    showAddFieldAliasModal () {
      this.newFieldAliasName = ''
      this.selectedFieldAlias = {
        id: null
      }
      this.$refs.FieldAliasModal.show()
    },
    searchByText () {
      this.fields = this.fetched_fields.filter(record => {
        return record.field.includes(this.filter.replace(/\s+/g, '_').toLowerCase())
      })
    },
    getFieldAlias (processField) {
      this.currentField = processField
      this.fieldAliasLoaded = false
      Vue.axios.get('/settings/process_field_alias/' + processField.id, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.currentFieldAliases = res.data.field_alias
          this.fieldAliasLoaded = true
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    confirmDeleteField (processField) {
      this.currentField = processField
      this.$refs.deleteGrp.show()
    },
    deleteField () {
      Vue.axios.delete('settings/process_field/' + this.currentField.id, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.success) {
            for (var i = 0; i < this.fields.length; i++) {
              if (this.fields[i].id === res.data.field.id) {
                this.fields.splice(i, 1)
              }
            }
            this.currentFieldAliases = null
            Vue.toasted.show('Sucessfully delete')
            this.$refs.deleteGrp.hide()
          } else {
            Vue.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  },
  validations: {
    newFieldName: {
      required,
      isUnique (value, vm) {
        value = value.trim().replace(/\s+/g, '_').toLowerCase()
        if (!value || this.newFieldName.name === value) return true
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            let groupNames = []
            groupNames = this.fields.filter(field => { return field.field === value && field.id !== this.currentField.id })
            resolve(!groupNames.length > 0)
          }, 350 + Math.random() * 300)
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped> 

.required {
  color: red;
}

.custom-select {
  background: none;
}

.col-auto{
  max-height: 150px;
  overflow: scroll;
}

.btn-secondary:hover {
}

#groups {
  overflow-y: scroll;
  height: 278px;
  background-color: #f7f7f7;
}

.card {
  cursor: pointer;
  background: #ebeef3;
  border-radius: 10px;
  .bar {
    width: 100%;
    height: 10px;
    border-radius: 10px 10px 0 0;
  }
  .card-header {
  border-radius: 10px 10px 0 0;
    background-color: #f7f7f7;
    padding: 1rem;
  }
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
  height: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0,0,0,.5);
  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}

.currFields {
  float: left;
  width: 33.3%;
  padding: 10px;
  border: 2px solid #f7f7f7;
  background-color: rgb(228, 229, 233) ;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.headers {
  padding-bottom: 4px;
}

.selectedField {
  border-left: 5px solid rgb(124, 124, 124);
  padding: 10px 15px 10px 10px;
}

.searchBox {
  margin-top: -9px;
  border-radius: 40px;
  width: 133%;
}

.addGroupBtn {
  margin-top: -9px;
}

.groupName {
  background-color: rgb(228, 229, 233);
}

.actionBtn {
  padding-top: 10px;
}

.editBtnSelect {
  margin-right: 4%;
}

.unselectedRows {
  padding: 10px 15px 10px 15px;
}

.labelBody {
  overflow: scroll;
  background-color: #f7f7f7;
  padding: 10px 4px 10px 10px;
  height:278px;
}

.fieldEditBtn {
  padding-right: 8px;
}

.processTypeLabel {
  margin-top: 6px;
  font-size: 15px;
}

.selProType {
  margin-left: 17px
}

.formselectPT {
  margin-bottom: 10px;
  border-radius: 25px;
  width: 25.5%;
  margin-left: -10px;
}

/deep/ .custom-multiselect .multiselect__content-wrapper {
  box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.35) !important;
  border: 2px solid #e8e8e8;
  border-width: 1px 2px 3px 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/settings/manageFields.vue